import { graphql } from 'react-relay';

export const tradeGeneralOnboardingQuery = graphql`
    query tradeGeneralOnboardingQuery($userId: String!) {
        viewer {
            user(userId: $userId) {
                verifiedTradeSubStatus
            }
        }
    }
`;
